export enum ApplicationStatus {
  InReview = "In Review",
  Pending = "Pending",
  Inactive = "Inactive",
  Active = "Active",
  Declined = "Declined",
  Cancelled = "Cancelled",
  SetDefault = "SetDefault",
  Complete = "Complete",
}

export enum NMIAccountHolderType {
  Business = "business",
  Personal = "personal",
}

export enum NMIAccountType {
  Checking = "checking",
  Savings = "savings",
}

export enum MerchantAccountsGateway {
  Fiserv = "Fiserv",
  NMI = "NMI",
}

export enum NMIProcessorTypes {
  Tsys = "Tsys",
  ElavonEMV = "ElavonEMV",
  ElavonViaConex = "ElavonViaConex",
  FirstDataNashville = "FirstDataNashville",
  FirstDataRapidConnectNashvilleNorthEMV = "FirstDataRapidConnectNashvilleNorthEMV",
  GlobalCollect = "GlobalCollect",
  FirstDataCanada = "FirstDataCanada",
  FirstDataOmaha = "FirstDataOmaha",
  FirstDataRapidConnectNashvilleEMV = "FirstDataRapidConnectNashvilleEMV",
  FirstDataRapidConnectOmahaEMV = "FirstDataRapidConnectOmahaEMV",
  FirstDataRapidConnectCardnetNorthEMV = "FirstDataRapidConnectCardnetNorthEMV",
  FirstDataNashvilleNorthV2 = "FirstDataNashvilleNorthV2",
  FirstDataNashvilleNorth = "FirstDataNashvilleNorth",
  GlobalPaymentsEastEMV = "GlobalPaymentsEastEMV",
}
